import { FormSelectId } from '@nexelem/form-components';
import { cn } from '@nexelem/utils';
import { useCustomTranslation } from '../../../../../hooks';
import { useLemmaMachineAreasList } from './useLemmaMachineAreasList';

export const LemmaMachineAreaSelect = () => {
  const { tWrapper } = useCustomTranslation('common');
  const { data: areas } = useLemmaMachineAreasList();

  const options = (areas ?? []).map((area) => {
    return {
      id: area.id,
      label: area.name,
    };
  });

  return (
    <FormSelectId
      required
      className="w-full"
      label={tWrapper('area')}
      maxWidth="full"
      name="queueAreaId"
      options={options}
      placeholder={tWrapper('select')}
      renderOption={({ className, ...props }, option) => {
        const area = areas?.find((item) => item.id === option.id);
        return (
          <li className={cn(className, 'inline-flex items-center gap-2')} key={option.id} {...props}>
            {area?.hexColor ? (
              <span className="size-4 rounded-full" style={{ backgroundColor: `#${area.hexColor}` }} />
            ) : null}
            <span>{option.label}</span>
          </li>
        );
      }}
    />
  );
};
